import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import useGetJobPhase from "hooks/jobs/job-phases/useGetJobPhase";
import Modal from "modules/Modal/Modal";
import JobPhaseChecklist from "./ScheduleJobPhase/JobPhaseChecklist";

export default function DispatchChecklistModal({
  open,
  jobPhaseId,
  onClose,
}: {
  open: boolean;
  jobPhaseId: string | null;
  onClose: () => void;
}) {
  const { data: jobPhase, loading, error } = useGetJobPhase({ id: jobPhaseId });

  return (
    <Modal open={open} onClose={onClose} styles={{ maxWidth: "840px", height: "auto" }}>
      <MDBox p={3}>
        <MDTypography variant="h5" fontWeight="medium" mb={1}>
          Edit Phase Checklist
        </MDTypography>
        {jobPhase ? (
          <MDTypography variant="button" color="text" mb={2} display="block">
            {jobPhase.job?.externalId || "Job"} {jobPhase.productName ? `- ${jobPhase.productName}` : ""}
          </MDTypography>
        ) : null}

        {!jobPhaseId || loading ? (
          <MDTypography variant="body2" color="text">
            Loading checklist...
          </MDTypography>
        ) : null}

        {!loading && error ? (
          <MDTypography variant="body2" color="error">
            Failed to load checklist items for this phase.
          </MDTypography>
        ) : null}

        {!loading && !error && jobPhase ? <JobPhaseChecklist key={jobPhase.id} jobPhase={jobPhase} /> : null}
      </MDBox>
    </Modal>
  );
}
